import { useContext } from 'react';
import LoginContext from './context/loginContext';
import RootRoute from './RootRoute';

function App() {
  const { authenticated } = useContext(LoginContext);
  return (
    <>
      <RootRoute isAuthenticated={authenticated} />
    </>
  );
}

export default App;
